import { useContext, useEffect } from 'react';
import BPHeader from './BPHeader';
import BPFooter from './BPFooter';
import { useStepper } from '../Stepper';
import BPGrid from './BPTestTable';

// Context
import { BusinessPartnerContext } from './BusinessPartnerCard';
import BPSection from './BPSection';
import { SECTIONS } from './utils';

const BPAddress = () => {
  const { localBPData, isEditing, handleOnChange, dropdownValues, errors } = useContext(BusinessPartnerContext);

  return (
    <>
      <section className="bp-address">
        <BPHeader />
        <BPSection
          sections={SECTIONS['bp-address']}
          isEditing={isEditing}
          localBPData={localBPData}
          dropdownValues={dropdownValues}
          errors={errors}
          handleOnChange={handleOnChange}
        />
      </section>
      <BPFooter />
    </>
  );
};

export default BPAddress;
